import { createContext, FC, ReactNode, useContext } from 'react';

// The merchant theme's `isDefault` flag, surfaced to consumers that need to
// switch behaviour on it WITHOUT changing any semantic-color token (PAA-2711).
//
// Used by the Xero checkout ACC (Automatic Currency Conversion) currency
// switcher / picker to choose its accent: the brand colour when the theme is the
// default (true) or the flag is omitted, or the merchant text colour when it is
// a saved theme (false). Xero's theme comes from `useInvoiceTheme`, which the
// deep ACC components can only reach through a context. (The payment-link ACC
// reads the equivalent `linkInfoData.theme.isDefault` from its own store.)
// Defaults to `undefined` (treated as the default theme → brand accent) so
// consumers outside a provider behave as before.
const ThemeIsDefaultContext = createContext<boolean | undefined>(undefined);

interface ThemeIsDefaultProviderProps {
  value?: boolean;
  children: ReactNode;
}

export const ThemeIsDefaultProvider: FC<ThemeIsDefaultProviderProps> = ({ value, children }) => (
  <ThemeIsDefaultContext.Provider value={value}>{children}</ThemeIsDefaultContext.Provider>
);

export const useThemeIsDefault = (): boolean | undefined => useContext(ThemeIsDefaultContext);
